import { useState } from "react"
import done from "../../assets/img/done.svg"
import showMoreImg from "../../assets/img/show-more.svg"

import ico1 from "../../assets/img/ico-1.svg"
import ico2 from "../../assets/img/ico-2.svg"
import ico3 from "../../assets/img/ico-3.svg"
import ico4 from "../../assets/img/ico-4.svg"
import ico5 from "../../assets/img/ico-5.svg"
import ico6 from "../../assets/img/ico-6.svg"
import ico7 from "../../assets/img/ico-7.svg"
import ico8 from "../../assets/img/ico-8.svg"
import ico9 from "../../assets/img/ico-9.svg"
import ico10 from "../../assets/img/ico-10.svg"
import ico11 from "../../assets/img/ico-11.svg"

import "./styles.scss"

const ShortAdd = ({ lang }) => {
  const [showMore, setShowMore] = useState(false)

  const roContent = () => {
    return (
      <div class="single-service services-container" >
        <div class="inner-data">
          <div class="service-detail">
            <div class="col-det">
              <p class="headf1" id="services">Servicii Auto Chip service</p>
              <div class="flex-detail">
                <div class="col-one">
                  <img src={ico1} alt="" />
                  <div>
                    <h2 class="col-head" >Fabricarea și reparația cheilor auto
                    </h2>
                    <ul class="unlist">
                      <li>
                        <img src={done} alt="" /> Fabricarea duplicatelor de chei după model
                      </li>
                      <li>
                        <img src={done} alt="" /> Fabricarea cheilor cu cip
                      </li>
                      <li>
                        <img src={done} alt="" /> Copierea cipurilor, înlocuirea carcaselor
                      </li>
                      <li>
                        <img src={done} alt="" /> Reparația telecomenzilor originale pentru închiderea centralizată și altele
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-one">
                  <img src={ico2} alt="" />
                  <div>
                    <h2 class="col-head">Diagnosticare computerizată</h2>
                    <ul class="unlist">
                      <li>
                        <img src={done} alt="" /> Reparație și programare imobilizatoare
                      </li>
                      <li>
                        <img src={done} alt="" /> Legarea cheilor și cipurilor Mercedes, BMW, Vag (VW, Audi, Seat, Skoda) și alte mărci
                      </li>
                      <li>
                        <img src={done} alt="" /> Eliminare software a DPF, EGR, catalizatorului, AdBlue
                      </li>
                      <li>
                        <img src={done} alt="" /> Chip-tuning stage 1, stage 2
                      </li>
                      <li>
                        <img src={done} alt="" /> Programarea si configurarea 
                        electronicii
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-one">
                    <img src={ico7} alt="" />
                    <div>
                      <h2 class="col-head">Reparația lacăturilor auto</h2>
                      <ul class="unlist">
                      <li>
                          <img src={done} alt="" /> Deblocare, reparație și întreținere lacăt auto
                        </li>
                        <li>
                          <img src={done} alt="" /> Deschiderea mașinii fără deteriorare
                        </li>
                        <li>
                          <img src={done} alt="" /> Verificare și reparație închidere centralizată electrică
                        </li>
                        <li>
                          <img src={done} alt="" /> Verificare și reparație geamuri electrice
                        </li>
                        <li>
                          <img src={done} alt="" /> Verificare și reparație geamuri electrice
                        </li>
                      </ul>
                    </div>
            
                  </div>
              </div>
              {showMore && (
                <div class="flex-detail mapedCategories">
                                    <div class="col-one">
                    <img src={ico10} alt="" />
                    <div>
                      <h2 class="col-head">Electrica auto</h2>
                      <ul class="unlist">
                        <li>
                          <img src={done} alt="" /> Verificare și reparație echipamente electrice
                        </li>
                        <li>
                          <img src={done} alt="" /> Crash Data Reset – ștergerea erorilor airbag din memorie
                        </li>
                        <li>
                          <img src={done} alt="" /> Citirea și ștergerea codurilor de eroare din memorie
                        </li>
                        <li>
                          <img src={done} alt="" /> Activarea elementelor de acționare
                        </li>
                        <li>
                          <img src={done} alt="" /> Verificare și reglare a scurgerilor de curent
                        </li>
                        <li>
                          <img src={done} alt="" /> Instalare iluminare ambient light
                        </li>
                        <li>
                          <img src={done} alt="" /> Reparație ventilator habitaclu
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-one">
                  <img src={ico4} alt="" />
                  <div>
                    <h2 class="col-head">Izolare fonică
                    </h2>
                    <ul class="unlist">
                        <li>
                          <img src={done} alt="" /> Izolare fonică a caroseriei
                        </li>
                        <li>
                          <img src={done} alt="" /> Izolare fonică a anvelopelor
                        </li>
                        <li>
                          <img src={done} alt="" /> Izolare fonică a compartimentului motor
                        </li>

                    </ul>
                  </div>
                </div>
                </div>
              )}

              <div class="show-more" onClick={() => setShowMore(!showMore)}>
                {showMore ? "Ascunde" : "Toate serviciile"}
                <img
                  src={showMoreImg}
                  alt=""
                  style={{ rotate: !showMore ? "0deg" : "180deg" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const ruContent = () => {
    return (
      <div class="single-service services-container">
        <div class="inner-data">
          <div class="service-detail">
            <div class="col-det">
              <p class="headf1" id="services">Услуги Auto Chip service</p>
              <div class="flex-detail">
                <div class="col-one">
                  <img src={ico1} alt="" />
                  <div>
                    <h2 class="col-head">Изготовление и ремонт автомобильных ключей</h2>
                    <ul class="unlist">
                      <li>
                        <img src={done} alt="" /> Изготовление дубликатов ключей по образцу
                      </li>
                      <li>
                        <img src={done} alt="" /> Изготовление ключей по замку, изготовление чиповых ключей
                      </li>
                      <li>
                        <img src={done} alt="" /> Дублирование чипов, замена корпусов
                      </li>
                      <li>
                        <img src={done} alt="" /> Ремонт штатных пультов управления центральным замком и др.
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-one">
                  <img src={ico2} alt="" />
                  <div>
                    <h2 class="col-head">Компьютерная диагностика</h2>
                    <ul class="unlist">
                      <li>
                        <img src={done} alt="" /> Ремонт, программирование иммобилайзеров 
                      </li>
                      <li>
                        <img src={done} alt="" /> Привязка блоков управления Mercedes, BMW, Vag (VW, Audi, Seat, Skoda) и других марок
                      </li>
                      <li>
                        <img src={done} alt="" /> Программное удаление DPF, EGR, катализатора, adblue
                      </li>
                      <li>
                        <img src={done} alt="" /> Чип-тюнинг stage 1, stage 2
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-one">
                    <img src={ico7} alt="" />
                    <div>
                      <h2 class="col-head">Ремонт автомобильных замков</h2>
                      <ul class="unlist">
                      <li>
                          <img src={done} alt="" /> Разблокирование, ремонт и профилактика автозамков
                        </li>
                        <li>
                          <img src={done} alt="" /> Вскрытие автомобилей без повреждений
                        </li>
                        <li>
                          <img src={done} alt="" /> Диагностика и ремонт электрического центрального замка
                        </li>
                        <li>
                          <img src={done} alt="" /> Диагностика и ремонт стеклоподъёмников
                        </li>
                      </ul>
                    </div>
                  </div>
              </div>
              {showMore && (
                <div class="flex-detail mapedCategories">
                  <div class="col-one">
                    <img src={ico10} alt="" />
                    <div>
                      <h2 class="col-head">Автоэлектрика</h2>
                      <ul class="unlist">
                      <li>
                          <img src={done} alt="" /> Диагностика и ремонт электрооборудования
                        </li>
                        <li>
                          <img src={done} alt="" /> Тестирование датчиков
                        </li>
                        <li>
                          <img src={done} alt="" /> Активация исполнительных элементов
                        </li>
                        <li>
                          <img src={done} alt="" /> Чтение и удаление из памяти кодов неисправностей
                        </li>
                        <li>
                          <img src={done} alt="" /> Программирование и настройка электроники
                        </li>
                        <li>
                          <img src={done} alt="" /> Диагностика и исправление утечки тока
                        </li>
                        <li>
                          <img src={done} alt="" /> Установка эмбиент подсветки
                        </li>
                        <li>
                          <img src={done} alt="" /> Ремонт вентилятора печки
                        </li>
                        <li>
                          <img src={done} alt="" /> Crash data reset - удаление из памяти ошибок airbag
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-one">
                  <img src={ico4} alt="" />
                  <div>
                    <h2 class="col-head">Шумоизоляция</h2>
                    <ul class="unlist">
                       <li>
                          <img src={done} alt="" /> Шумоизоляция кузова
                        </li>
                        <li>
                          <img src={done} alt="" /> Шумоизоляция шин
                        </li>
                        <li>
                          <img src={done} alt="" /> Шумоизоляция моторного отдела
                        </li>
                    </ul>
                  </div>
                </div>
                </div>
              )}

              <div class="show-more" onClick={() => setShowMore(!showMore)}>
                {showMore ? "Свернуть" : "Показать"}
                <img
                  src={showMoreImg}
                  alt=""
                  style={{ rotate: !showMore ? "0deg" : "180deg" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  console.log("lang", lang.lang)
  const content = lang === "ro" ? roContent() : ruContent()
  return content
}

export default ShortAdd
